<sc-activity-list-item [activity]="activity" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-user-plus"></i>
    {{ texts.addedToPoolPrefix[language] }} @if (context != 'candidate') { <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> } {{ texts.addedToPoolSuffix[language] }}
</sc-activity-list-item>
